import { Link, NavLink, useNavigate } from "react-router-dom";
import { tokenDecode } from "../../../utils/helper";
import { useContext, useMemo, useRef, useState , useCallback } from "react";
import { createPortal } from "react-dom";
import logoimg from "../../../../src/icons/image_2024.png";
import styles from "./Side_bar.module.css";
import { useEffect } from "react";
// import dashboard from "../../../icons/dashboard.png";
import calendar from "../../../icons/calendar.png";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdSearch,
  MdClose,
  MdMoreHoriz,
  MdApps,
  MdShoppingCart,
} from "react-icons/md";
import MobileNavbar from "../mobileNavbar";
// import { apiurl } from "../../../pages/chat/config/config";
// import { socket } from "../../../pages/chat/config/socket";
import { toast } from "react-toastify";
import { HiOutlineBell } from "react-icons/hi";
import { useSidebar } from "../../../context/SidebarContext";
import { useLocation } from "react-router-dom";
import { TokenContext } from "../../../context/TokenContext";
import { BsShopWindow, BsDoorOpen } from "react-icons/bs";
import { TbFileInvoice } from "react-icons/tb";
import { useProfile } from "../../../context/ProfileContext";
import { IoHomeOutline } from "react-icons/io5";
import { useToken } from "../../../hooks/token/useToken";
import jwt_decode from "jwt-decode";
import { httpService } from "../../../services/httpService";
import AddAppointment from "../../../pages/Calendar/BigCalendar/appointmentcalendar/AddAppointment";
import { FaChevronDown, FaPlus, FaCheckCircle, FaInfoCircle, FaExclamationTriangle, FaEye, FaEyeSlash, FaBars } from "react-icons/fa";
import { Building2 } from "lucide-react";
import { formatDistanceToNow } from 'date-fns';
import socket from "../../../services/socket";
import PlanChangeDrawer from "../../Setting/ProfileSettings/PlanChangeDrawer";
import { usePlanChange } from "../../Setting/ProfileSettings/usePlanChange";
import {
  fetchVendorSetup,
  extractCompletedStepIds,
  computeRequiredStepIds,
} from "../../../utils/vendorSetupSteps";
import PlanExpiredOverlay from "../../../components/PlanExpiredOverlay";
import BookingDetailsDrawer from "../../../pages/Orders/BookingDetailsDrawer";
import { orderEvents } from "../../../lib/orderEvents";

// Configurable Top Navigation Items configuration for Desktop / Tablet
export const TOP_NAV_ITEMS = [
  {
    id: "home",
    label: "Home",
    icon: (props) => <IoHomeOutline className="h-8 w-8" {...props} />,
    route: "/home",
    permissionName: "Home",
    isPrimary: true,
    isAllowed: (ctx) =>
      ctx.currentRole === "executive" &&
      ctx.allowedByName("Home") &&
      !ctx.isShopOnly,
    isActive: (pathname) =>
      pathname === "/home" || pathname.startsWith("/home/"),
  },
  {
    id: "search",
    label: "Search",
    icon: (props) => <MdSearch className="h-8 w-8" {...props} />,
    isSearch: true,
    isPrimary: true,
    isAllowed: (ctx) =>
      ctx.currentRole === "executive" &&
      (ctx.isSearchPermitted ? ctx.isSearchPermitted() : true),
    isActive: (pathname) =>
      pathname.startsWith("/search_clients"),
  },
  {
    id: "orders",
    label: "Orders",
    icon: (props) => <MdShoppingCart className="h-8 w-8" {...props} />,
    route: "/admin/order-management/orders",
    permissionName: "Orders",
    isPrimary: true,
    isAllowed: (ctx) =>
      ctx.currentRole === "executive" &&
      (ctx.isOrdersPermitted ? ctx.isOrdersPermitted() : true),
    isActive: (pathname) =>
      pathname.startsWith("/admin/order-management/orders") ||
      pathname.startsWith("/orderList"),
  },
  {
    id: "calendar",
    label: "Calendar",
    icon: (props) => (
      <img src={calendar} className="h-8 w-8" alt="Calendar" {...props} />
    ),
    route: "/calendar",
    permissionName: "Calendar",
    isPrimary: false,
    isAllowed: (ctx) =>
      ctx.currentRole === "executive" && ctx.allowedByName("Calendar"),
    isActive: (pathname) =>
      pathname === "/calendar" || pathname.startsWith("/calendar/"),
  },
  {
    id: "invoice",
    label: "Invoice",
    icon: (props) => <TbFileInvoice className="h-8 w-8" {...props} />,
    route: "/invoice",
    permissionName: "Invoice",
    isPrimary: false,
    isAllowed: (ctx) =>
      ctx.currentRole === "executive" && ctx.allowedByName("Invoice"),
    isActive: (pathname) => {
      const activeRoutes = ["/invoice"];
      return activeRoutes.some((route) => pathname.startsWith(route));
    },
  },
  {
    id: "pos",
    label: "POS Sale",
    icon: (props) => <BsShopWindow className="h-8 w-8" {...props} />,
    route: "/pos",
    permissionName: "POS Sale",
    isPrimary: false,
    isAllowed: (ctx) =>
      ctx.currentRole === "executive" &&
      ctx.allowedByName("POS Sale") &&
      ctx.petShopActive,
    isActive: (pathname) => {
      const activeRoutes = ["/pos"];
      return activeRoutes.some((route) => pathname.startsWith(route));
    },
  },
  {
    id: "room_management",
    label: "Room Management",
    icon: (props) => <BsDoorOpen className="h-8 w-8" {...props} />,
    route: "/admin/room_management",
    permissionName: "Room Management",
    isPrimary: false,
    isAllowed: (ctx) => ctx.currentRole === "executive" && ctx.boardingActive,
    isActive: (pathname) => pathname.startsWith("/admin/room_management"),
  },
];

const TRIAL_BANNER_KEY = "trialBannerDismissedDate";
const getTodayStr = () => new Date().toISOString().split("T")[0];
const isTrialBannerDismissedToday = () => {
  try { return localStorage.getItem(TRIAL_BANNER_KEY) === getTodayStr(); }
  catch { return false; }
};
const dismissTrialBannerForToday = () => {
  try { localStorage.setItem(TRIAL_BANNER_KEY, getTodayStr()); } catch {}
};

const cleanExpiredCachedTokens = () => {
  const tokens = JSON.parse(localStorage.getItem("cachedToken") || "{}");
  let changed = false;

  Object.entries(tokens).forEach(([role, token]) => {
    try {
      const decoded = jwt_decode(token);
      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        delete tokens[role];
        changed = true;
      }
    } catch (err) {
      // Corrupt token → remove it
      delete tokens[role];
      changed = true;
    }
  });

  if (changed) {
    if (Object.keys(tokens).length === 0) {
      localStorage.removeItem("cachedToken");
    } else {
      localStorage.setItem("cachedToken", JSON.stringify(tokens));
    }
  }
};

// Save a role token in localStorage
const saveRoleToken = (role, token) => {
  let tokens = {};

  try {
    tokens = JSON.parse(localStorage.getItem("cachedToken") || "{}");
  } catch (e) {
    console.warn("Corrupted cachedToken detected. Resetting.");
    localStorage.removeItem("cachedToken");
    tokens = {};
  }

  tokens[role] = token;
  localStorage.setItem("cachedToken", JSON.stringify(tokens));
};

// Get a role token from localStorage
const getRoleToken = (role) => {
  try {
    const tokens = JSON.parse(localStorage.getItem("cachedToken") || "{}");
    return tokens[role] || null;
  } catch {
    localStorage.removeItem("cachedToken");
    return null;
  }
};

const Sidebar = () => {
  const decoded = tokenDecode();
  // const location = useLocation();
  const { decodedData, updateToken } = useContext(TokenContext);
  const data = decodedData?.data || decoded?.data || {};
  useEffect(() => {
    const fetchEmployeeServices = async () => {
      const userId = data?.user?._id;
      const employeeId = data?.user?.employee_id;
      const isOwner = data?.user?.is_owner;

      // Only fetch if this is an employee (not owner)
      if (isOwner === 0 && employeeId) {
        try {
          setLoadingEmployee(true);
          const response = await httpService.get(
            `/employees/getEmployee/${employeeId}`,
          );
          // Adjust the path based on your actual API response structure
          const empData = response.data;
          // Assuming assigned services are in `assigned_service_categories` or similar
          const assigned = empData?.service_category || [];
          setEmployeeServices(assigned);
        } catch (err) {
          console.error("Failed to fetch employee services:", err);
          setEmployeeServices([]);
        } finally {
          setLoadingEmployee(false);
        }
      } else {
        // For admin/owner, we don't need employee services
        setLoadingEmployee(false);
      }
    };

    if (data?.user?._id) {
      fetchEmployeeServices();
    }
  }, [data?.user?._id, data?.user?.employee_id, data?.user?.is_owner]);

  const [showFaqDropdown, setShowFaqDropdown] = useState(false);
  const faqDropdownRef = useRef(null);

  // Determine current role reliably
  const currentRole =
    data?.user?.role_data?.name || data?.user?.role_type || "unknown";

  const normalizePlanCategory = (categories = []) =>
    categories.map((cat) => ({
      ...cat,
      service_type:
        Array.isArray(cat.service_type) && cat.service_type.length > 0
          ? cat.service_type
          : [
              {
                service_type_name: cat.service_category_name,
                service_category_type_id:
                  cat.type_id ?? cat.service_category_id,
                service_category_id: cat.service_category_id,
              },
            ],
    }));

  useEffect(() => {
    const originalRole = localStorage.getItem("originalRole");

    if (!originalRole && currentRole !== "unknown") {
      localStorage.setItem("originalRole", currentRole);
    }
  }, [currentRole]);

  // Determine which roles we can switch to
  // const canSwitchToExecutive = currentRole !== "executive";
  // const canSwitchToAdmin = currentRole !== "admin";

  const navigate = useNavigate();

  if (!decodedData === true) navigate("/");
  const expirationDate = new Date(decoded?.exp * 1000);
  const now = new Date();

  if (!expirationDate || expirationDate < now) {
    navigate("/");
  }

  const isAdminUser =
    data?.user?.role_data?.name === "admin" ||
    data?.user?.role_data?.name === "manager";

  // const [sidebarShow, setsidebarShow] = useState(1);
  // const [isReportDropDown, setIsReportDropDown] = useState(false);
  const [isDropDown, setIsDropDown] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { setShowSidebar, toggleSidebar } = useSidebar();
  const { isEmployee } = useToken();
  // const [changePlanDrawerOpen, setChangePlanDrawerOpen] = useState(false);

  // change password state
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [employeeServices, setEmployeeServices] = useState([]);
  const [loadingEmployee, setLoadingEmployee] = useState(true);
  const [bookingDetailsDrawerOpen, setBookingDetailsDrawerOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8) {
      errors.push("At least 8 characters");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("At least one uppercase letter");
    }
    if (!/\d/.test(password)) {
      errors.push("At least one number");
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      errors.push("At least one special character");
    }
    return errors;
  };

  const passwordValidationFeedback = passwordData.newPassword
    ? validatePassword(passwordData.newPassword)
    : [];
  const confirmPasswordFeedback =
    passwordData.confirmPassword &&
    passwordData.newPassword !== passwordData.confirmPassword
      ? "Passwords do not match"
      : "";

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setErrors({});

    const newPassError = validatePassword(passwordData.newPassword);

    if (newPassError.length) {
      setErrors({ newPassword: newPassError });
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setErrors({ confirmPassword: "Passwords do not match" });
      return;
    }

    setLoading(true);

    try {
      await httpService.post("/user/changePassword", {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
        confirmPassword: passwordData.confirmPassword,
      });

      toast.success("Password changed successfully!");
      setShowChangePassword(false);
      resetForm();
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to change password",
      );
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setPasswordData({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    setErrors({});
  };

  // State for the new add sale dropdown
  const [showAddSaleDropdown, setShowAddSaleDropdown] = useState(false);
  const [showMoreDropdown, setShowMoreDropdown] = useState(false);
  const moreDropdownRef = useRef(null);
  const morePanelRef = useRef(null);
  const [isStaffSearchOpen, setIsStaffSearchOpen] = useState(false);
  const staffSearchRef = useRef(null);
  const staffSearchPanelRef = useRef(null);
  const [isAdminSearchOpen, setIsAdminSearchOpen] = useState(false);
  const adminSearchRef = useRef(null);
  const addSaleDropdownRef = useRef(null);
  const addSalePanelRef = useRef(null); 
  const [showOrderDrawer, setShowOrderDrawer] = useState(false);
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [planBannerDismissed, setPlanBannerDismissed] = useState(false);
  // Get services and menu permissions from ProfileContext
  const {
    services = [],
    fetchProfile,
    clearProfile,
    menuPermissions = [],
    profileData,
    rawServiceCategory,
  } = useProfile();

  const isFreePlan = profileData?.accountType === "Free Forever";

  const isShopOnly = useMemo(() => {
    if (!rawServiceCategory || rawServiceCategory.length === 0) return false;
    const isPetShopOrPosCategory = (cat) => {
      const name = cat.service_category_name?.toLowerCase() || "";
      return name === "pet shop" || name === "pos";
    };
    const nonShop = rawServiceCategory.filter(
      (cat) => !isPetShopOrPosCategory(cat),
    );
    return nonShop.length === 0;
  }, [rawServiceCategory]);
  const fetchFreshPlans = useCallback(async () => {
    setLoadingPlans(true);
    try {
      const response = await httpService.get(
        `/subscriptionpricing/getSubscriptionPricing?t=${Date.now()}`,
      );
      const rawPlans = response.data || [];
      const normalizedPlans = rawPlans.map((plan) => ({
        ...plan,
        plan_category: normalizePlanCategory(plan.plan_category || []),
      }));
      setPlans(normalizedPlans);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
      setLoadingPlans(false);
    }
  }, []);
  // Initial fetch
  useEffect(() => {
    fetchFreshPlans();
  }, [fetchFreshPlans]);

  // const { getFeaturesToLose } = usePlans();
  const onPlanChange = useCallback(
    async (plan, reason, primaryId, optionalIds) => {
      try {
        await httpService.post("/vendors/vendorUpgradePlan", {
          vendorId: profileData._id,
          subscriptionPlanId: plan._id,
          selectedCategories: {
            primary: primaryId,
            optional: optionalIds,
          },
          reason,
        });
        await fetchProfile();
        await fetchFreshPlans();
        toast.success(`Plan changed to ${plan.plan_name}`);

        // ── Getting Started redirect logic ─────────────────────────────
        // Downgrades do not trigger or regenerate the Getting Started flow.
        if (reason === "downgrade") return;

        // For upgrades and service-category updates:
        // 1. Fetch the vendor's current setup progress from the DB.
        // 2. Compute the required steps for the new plan + chosen categories.
        // 3. If all required steps are already done, stay on Dashboard.
        //    Otherwise, clear the completion flag and redirect to Getting Started.
        const vendorId = profileData._id;
        let completedIds = [];
        try {
          const setupData = await fetchVendorSetup(vendorId);
          completedIds = extractCompletedStepIds(setupData);
        } catch (setupErr) {
          console.warn(
            "Could not fetch setup progress after plan change:",
            setupErr,
          );
        }

        const newPlanCategories = plan.plan_category || [];
        const requiredIds = computeRequiredStepIds(
          newPlanCategories,
          optionalIds || [],
          primaryId || null,
        );

        const allRequiredDone =
          requiredIds.length > 0 &&
          requiredIds.every((id) => completedIds.includes(id));

        if (allRequiredDone) {
          // All steps from the new plan are already complete — no redirect.
          try {
            sessionStorage.setItem("vendorSetupComplete", "true");
          } catch (_) {}
        } else {
          // Pending steps exist — send vendor to Getting Started.
          try {
            sessionStorage.setItem("vendorSetupComplete", "false");
          } catch (_) {}
          navigate("/admin/getting-started");
        }
        // ── End Getting Started redirect logic ─────────────────────────
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to change plan");
        throw error;
      }
    },
    [profileData, fetchProfile, fetchFreshPlans, navigate],
  );
  const {
    changePlanDrawerOpen,
    setChangePlanDrawerOpen,
    selectedPlan,
    selectedOptionalCategories,
    setSelectedOptionalCategories,
    selectedPrimaryCategory,
    setSelectedPrimaryCategory,
    showUpgradeConfirm,
    showDowngradeConfirm,
    setShowUpgradeConfirm,
    setShowDowngradeConfirm,
    handleUpgradeDowngrade,
    handleConfirmPlanChange,
    getActivePlanInfo,
    shouldShowDowngrade,
  } = usePlanChange(plans, profileData, onPlanChange);
  const vendorSubscriptionPlans = profileData?.subscriptionPlan;
  const currentPlan = vendorSubscriptionPlans?.find(
    (p) => p.status == 1 || p.status == "active",
  );

  let planExpired = null;

  if (currentPlan) {
    const now = new Date();
    const endDate = currentPlan.end_date
      ? new Date(currentPlan.end_date)
      : null;
    const isExpired =
      currentPlan.is_expired === true || // explicit flag
      (endDate && endDate < now); // or end date is past

    if (isExpired) {
      planExpired = {
        value: true,
        message: `Your ${currentPlan.plan_name} plan has expired. Renew or upgrade to restore full access.`,
      };
    }
  }

  const planWarning = useMemo(() => {
    if (!currentPlan || !currentPlan.end_date || !currentPlan.start_date) {
      return null;
    }

    const now = new Date();
    const start = new Date(currentPlan.start_date);
    const end = new Date(currentPlan.end_date);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;

    // total plan duration in days (rounded)
    const totalDays = Math.round((end - start) / (1000 * 60 * 60 * 24));

    // days remaining (don't go below 0)
    const diffDays = Math.max(
      0,
      Math.ceil((end - now) / (1000 * 60 * 60 * 24)),
    );

    if (diffDays <= 0) return null;

    const isFreeTrial = totalDays >= 20 && totalDays <= 22;

    if (isFreeTrial) {
      return {
        days: diffDays,
        isFreeTrial: true,
        headline: `${diffDays} ${diffDays === 1 ? "day" : "days"} left in your free trial`,
        subtext: "Choose a plan any time to keep your account active",
        cta: "Choose a plan",
      };
    }

    if (diffDays <= 5) {
      return {
        days: diffDays,
        isFreeTrial: false,
        headline: `${diffDays} ${diffDays === 1 ? "day" : "days"} left in your plan`,
        subtext: "Choose a plan any time to keep your account active",
        cta: "Choose a plan",
      };
    }

    return null;
  }, [currentPlan]);
  const updateHeaderHeight = useCallback(() => {
    if (dropdownRef.current) {
      const h = dropdownRef.current.offsetHeight;
      document.documentElement.style.setProperty("--top-navbar-height", `${h}px`);
    }
  }, []);

  useEffect(() => {
    updateHeaderHeight();
    const timer = setTimeout(updateHeaderHeight, 100);
    window.addEventListener("resize", updateHeaderHeight);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, [planWarning, planExpired, planBannerDismissed, isMobile, updateHeaderHeight]);

  // Refetch when drawer opens
  useEffect(() => {
    if (changePlanDrawerOpen) {
      fetchFreshPlans();
    }
  }, [changePlanDrawerOpen, fetchFreshPlans]);

  const logouthandler = () => {
    localStorage.removeItem("us_st_d");
    localStorage.removeItem("cachedToken"); // clear cached role tokens
    localStorage.removeItem("originalRole");

    clearProfile();
  };

  const allowedByName = (menuName) => {
    if (!menuPermissions || menuPermissions.length === 0) return true;

    const firstEntry = menuPermissions[0];

    const isOldPlan = Array.isArray(firstEntry?.role_permissions);
    if (isOldPlan) return true;

    const userRole = data?.user?.role_data?.name?.toLowerCase();

    const matchingPermissions = menuPermissions.find(
      (p) => p.menu_name === menuName,
    );

    if (!matchingPermissions) return false;

    if (matchingPermissions.is_enabled === false) return false;
    return profileData.allowedMenus.includes(matchingPermissions.menu_id);
  };

  const isSearchPermitted = () => {
    if (!menuPermissions || menuPermissions.length === 0) return true;
    const match = menuPermissions.find((p) => p.menu_name === "Search");
    if (!match) return true;
    if (match.is_enabled === false) return false;
    return profileData?.allowedMenus
      ? profileData.allowedMenus.includes(match.menu_id)
      : true;
  };

  const isOrdersPermitted = () => {
    if (!menuPermissions || menuPermissions.length === 0) return true;
    const match = menuPermissions.find(
      (p) => p.menu_name === "Orders" || p.menu_name === "Order Management",
    );
    if (!match) return true;
    if (match.is_enabled === false) return false;
    return profileData?.allowedMenus
      ? profileData.allowedMenus.includes(match.menu_id)
      : true;
  };
  // const visibleHeaderMenus = useMemo(() => {
  //   const userRole = data?.user?.role_data?.name?.toLowerCase();

  //   // Define all possible header menus
  //   const headerMenuList = [
  //     {
  //       name: "Home",
  //       path: "/home",
  //       icon: <IoHomeOutline className="h-8 w-8" />,
  //     },
  //     {
  //       name: "Calendar",
  //       path: "/calendar",
  //       icon: <img src={calendar} className="h-8 w-8" alt="calendar" />,
  //     },
  //     {
  //       name: "Invoice",
  //       path: "/invoice",
  //       icon: <TbFileInvoice className="h-8 w-8" />,
  //     },
  //     {
  //       name: "POS Sale",
  //       path: "/pos",
  //       icon: <BsShopWindow className="h-8 w-8" />,
  //     },
  //   ];

  //   // For executive role, ALWAYS show all menus
  //   // For OLD PLANS with no permissions - show all menus
  //   if (!menuPermissions || menuPermissions.length === 0) {
  //     return headerMenuList;
  //   }

  //   // Check if all permissions are false (old plan structure)
  //   const allFlagsFalse = menuPermissions.every(
  //     (p) => p.admin === false && p.manager === false && p.executive === false,
  //   );

  //   if (allFlagsFalse) return headerMenuList;

  //   return headerMenuList.filter((menu) => {
  //     const matchingPermissions = menuPermissions.filter(
  //       (p) => p.menu_name === menu.name,
  //     );
  //     if (!matchingPermissions.length) return false;

  //     return matchingPermissions.some((permission) => {
  //       if (!permission.is_enabled) return false;
  //       if (userRole === "admin") return permission.admin === true;
  //       if (userRole === "manager") return permission.manager === true;
  //       if (userRole === "executive") return permission.executive === true;
  //       return false;
  //     });
  //   });
  // }, [menuPermissions, data?.user?.role_data?.name]);

  // ensure services are fetched once on mount if missing
  useEffect(() => {
    let cancelled = false;
    const ensure = async () => {
      if (!services || services.length === 0) {
        try {
          await fetchProfile?.();
        } catch (err) {
          console.error("Sidebar: failed to fetch profile", err);
        }
      }
    };
    ensure();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    cleanExpiredCachedTokens();
  }, []);

  // optional: re-fetch if global event triggers (keeps Sidebar in sync)
  useEffect(() => {
    const handler = () => fetchProfile?.();
    window.addEventListener("servicesUpdated", handler);
    return () => window.removeEventListener("servicesUpdated", handler);
  }, []);

  const petShopActive = useMemo(() => {
    // If the user is an employee, check their assigned services
    const isEmployee = data?.user?.is_owner === 0 && data?.user?.employee_id;
    const servicesToCheck = isEmployee
      ? services.filter((service) =>
          employeeServices.some(
            (employeeService) =>
              employeeService.service_category_id.toString() ===
              service.service_category_id.toString(),
          ),
        )
      : services;

    return servicesToCheck.some(
      (s) =>
        (s.name?.toLowerCase() === "pet shop" ||
          s.category_name?.toLowerCase() === "pet store") &&
        s.isActive === 1,
    );
  }, [
    employeeServices,
    services,
    data?.user?.is_owner,
    data?.user?.employee_id,
  ]);

   const boardingActive = useMemo(() => {
          const isEmployee =
            data?.user?.is_owner === 0 && data?.user?.employee_id;
          const servicesToCheck = isEmployee
            ? services.filter((service) =>
                employeeServices.some(
                  (employeeService) =>
                    employeeService.service_category_id.toString() ===
                    service.service_category_id.toString(),
                ),
              )
            : services;

          return servicesToCheck.some((s) => {
            const name = (s.name || s.category_name || "").toLowerCase();
            const active = Number(s.isActive) === 1 || s.isActive === true;
            return name.includes("boarding") && active;
          });
        }, [
          employeeServices,
          services,
          data?.user?.is_owner,
          data?.user?.employee_id,
        ]);

  const [isTabletScreen, setIsTabletScreen] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth >= 768 && window.innerWidth < 1280;
  });

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setIsMobile(w < 768);
      setIsTabletScreen(w >= 768 && w < 1280);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) setShowSidebar(false);
  }, [isMobile]);

  // const [chatList, setchatList] = useState([]);
  // const [totalSeenCount, setTotalSeenCount] = useState(null);

  useEffect(() => {
    return () => {};
  }, []);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {

    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      !profilePanelRef.current?.contains(event.target)
    ) {
      setIsDropDown(false);
    }

    // Close the add sale dropdown if clicked outside
    if (
      showAddSaleDropdown &&
      addSaleDropdownRef.current &&
      !addSaleDropdownRef.current.contains(event.target) &&
      !addSalePanelRef.current?.contains(event.target)
    ) {
      setShowAddSaleDropdown(false);
    }
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target) &&
      !notificationPanelRef.current?.contains(event.target)
    ) {
      setShowNotifications(false);
    }
    if (
      showFaqDropdown &&
      faqDropdownRef.current &&
      !faqDropdownRef.current.contains(event.target)
    ) {
      setShowFaqDropdown(false);
    }
    if (
      isStaffSearchOpen &&
      staffSearchRef.current &&
      !staffSearchRef.current.contains(event.target) &&
      !staffSearchPanelRef.current?.contains(event.target)
    ) {
      setIsStaffSearchOpen(false);
    }
    if (
      isAdminSearchOpen &&
      adminSearchRef.current &&
      !adminSearchRef.current.contains(event.target)
    ) {
      setIsAdminSearchOpen(false);
    }
    if (
      showMoreDropdown &&
      moreDropdownRef.current &&
      !moreDropdownRef.current.contains(event.target) &&
      !morePanelRef.current?.contains(event.target)
    ) {
      setShowMoreDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    showAddSaleDropdown,
    isStaffSearchOpen,
    isAdminSearchOpen,
    showFaqDropdown,
    showMoreDropdown,
  ]);

  const [searchTerm, setSearchTerm] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const trimmedTerm = searchTerm.trim();
      if (trimmedTerm) {
        navigate(`/search_clients?search=${encodeURIComponent(trimmedTerm)}`);
      } else {
        console.log("Search term is empty. No redirect.");
      }
    }
  };

  const urlLocation = useLocation();

  const canSwitchToAdmin = () => {
    const originalRole = localStorage.getItem("originalRole");
    const cachedAdminToken = getRoleToken("admin");

    return originalRole === "admin" || !!cachedAdminToken;
  };

  const showSwitchToAdmin = currentRole === "executive" && canSwitchToAdmin();
  const showSwitchToExecutive = currentRole === "admin";
  const allowedPaths = [
    "/dashboard",
    "/admin/dashboard",
    "/admin/service-management/",
    "/admin/staff-management/employees",
    "/admin/clients-pets",
    "/admin/customer-onboarding-form",
    "/client_pets",
    "/admin/inventory-management/",
    "/admin/reports/",
    "/admin/settings/",
    // "/admin/room_management",
    "/admin/forms",
    "/admin/booking-management/",
    "/admin/order-management/",
    "/admin/expense-management/",
    "/admin/getting-started",
    "/admin/discounts",
    // Allow POS/Invoice only for non-employees (admins)
    ...(isEmployee ? [] : ["/pos", "/invoice"]),
    ...(isAdminUser ? ["/search_clients"] : []),
    ...(currentRole !== "executive" ? ["/admin/room_management"] : []),
  ];

  const handleRoleSwitch = async (role) => {
    const originalToken = localStorage.getItem("us_st_d");
    const originalRole = localStorage.getItem("originalRole");
    const currentRole = jwt_decode(originalToken).data.user.role_data.name;

    if (role === "admin" && originalRole !== "admin") {
      toast.error("You are not allowed to switch to Admin");
      return;
    }
    saveRoleToken(currentRole, originalToken);

    const cachedToken = getRoleToken(role);
    if (cachedToken) {
      updateToken(cachedToken);
      toast.success(`Switched to ${role} role`);
      navigate(role === "executive" ? "/home" : "/dashboard");
      return;
    }

    try {
      const res = await httpService.post("/user/switchrole", { role });
      const newToken = res.data?.token;

      if (!newToken) {
        toast.error("No token received from server");
        return;
      }

      // Cache token for this role
      saveRoleToken(role, newToken);

      // Update TokenContext
      updateToken(newToken);
      toast.success(`Switched to ${role} role`);
      navigate(role === "executive" ? "/home" : "/dashboard");
    } catch (error) {
      console.error("Role switch error:", error);
      toast.error(error.response?.data?.message || "Failed to switch role");
    }
  };

  const showSidebar = allowedPaths.some((path) =>
    urlLocation.pathname.startsWith(path),
  );

  useEffect(() => {
    showSidebar ? setShowSidebar(true) : setShowSidebar(false);
  }, [urlLocation]);

  const handleLogoClick = () => {
    console.log(
      "isShopOnly:",
      isShopOnly,
      "petShopActive:",
      petShopActive,
      "rawServiceCategory:",
      rawServiceCategory,
    );
    // Executive should always go to home
    if (data?.user?.role_data?.name === "executive") {
      navigate("/home");
      return;
    }

    // Then check for Dashboard permission
    const isDashboardAllowed = allowedByName("Dashboard");
    if (isDashboardAllowed) {
      navigate("/dashboard");
      return;
    }

    // Fallback to calendar if available
    const isCalendarAllowed = allowedByName("Calendar");
    if (isCalendarAllowed) {
      navigate("/calendar");
    } else {
      navigate("/home");
    }
  };

  const handleOrderDrawerClose = () => {
    setShowOrderDrawer(false);
  };

  const handleOrderSaved = () => {
    handleOrderDrawerClose();
    orderEvents.emit(); // ← notify every subscriber
  };

  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const notificationRef = useRef(null);
  const notificationPanelRef = useRef(null);
  const profileButtonRef = useRef(null);
  const profilePanelRef = useRef(null);

  // Inside the Sidebar component
  useEffect(() => {
    // Handle new notification pushed from backend
    const handleNewNotification = (notification) => {
      setNotifications((prev) => [notification, ...prev]);
      setUnreadCount((prev) => prev + 1);
    };

    // Handle unread count sync
    const handleUnreadCount = (count) => {
      setUnreadCount(count);
    };

    socket.on("new_notification", handleNewNotification);
    socket.on("unread_count", handleUnreadCount);
    socket.on("refresh_notifications", fetchNotifications);

    // Initial fetch (still useful to load history)
    fetchNotifications(); // your existing REST call

    return () => {
      socket.off("new_notification", handleNewNotification);
      socket.off("unread_count", handleUnreadCount);
      socket.off("refresh_notifications", fetchNotifications);
    };
  }, []);

  useEffect(() => {
    const handleOpenNotifications = () => {
      setShowNotifications(true);
    };

    document.addEventListener(
      "openNotificationsPanel",
      handleOpenNotifications,
    );
    return () => {
      document.removeEventListener(
        "openNotificationsPanel",
        handleOpenNotifications,
      );
    };
  }, []);

  // Fetch notifications from API
  const fetchNotifications = async () => {
    try {
      // Replace with your actual API endpoint
      const response = await httpService.get("/appnotifications");
      setNotifications(response.data.notifications);
      setUnreadCount(response.data.unreadCount);
      //setUnreadCount(response.data.notifications.filter(n => !n.isRead).length);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  // Mark a single notification as read
  const markAsRead = async (notificationId) => {
    try {
      // Replace with your actual API endpoint
      await httpService.put(`/appnotifications/${notificationId}/read`);
      setNotifications((prev) =>
        prev.map((notif) =>
          notif._id === notificationId ? { ...notif, isRead: true } : notif,
        ),
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  // Mark all notifications as read
  const markAllAsRead = async () => {
    try {
      // Replace with your actual API endpoint
      await httpService.put("/appnotifications/read-all");
      setNotifications((prev) =>
        prev.map((notif) => ({ ...notif, read: true })),
      );
      setUnreadCount(0);
    } catch (error) {
      console.error("Error marking all as read:", error);
    }
  };

  // Get icon based on notification type
  const getNotificationIcon = (type) => {
    switch (type) {
      case "success":
        return <FaCheckCircle className="h-5 w-5 text-green-500" />;
      case "warning":
        return <FaExclamationTriangle className="h-5 w-5 text-yellow-500" />;
      case "info":
        return <FaInfoCircle className="h-5 w-5 text-blue-500" />;
      default:
        return <HiOutlineBell className="h-5 w-5 text-gray-500" />;
    }
  };

  // Handle notification click to open order details
  const handleNotificationClick = async (notification) => {
    try {
      // Extract order_id from notification data
      const orderId = notification.data?.order_id;
      const bookingType = notification.data?.booking_type;

       setShowNotifications(false);
       await markAsRead(notification._id);
       if (
         notification.type === "form_submitted" ||
         notification.title?.toLowerCase().includes("form submitted")
       ) {
         // Extract phone number from notification body (e.g., "Form submitted by 9876543210")
         // Or use notification.data?.phone if your backend sends it
         const phone =
           notification.data?.phone || notification.body?.match(/\d{10}/)?.[0];

         if (!phone) {
           // If no phone found, default to onboarding page
           navigate("/admin/customer-onboarding-form");
           return;
         }

         try {
           
           const res = await httpService.get(
             `/customers/search?phone=${phone}`,
           );

           if (
             res.data &&
             (res.data._id || res.data.data?._id || res.data.exists)
           ) {
             navigate("/admin/clients-pets");
           } else {
             navigate("/admin/customer-onboarding-form");
           }
         } catch (err) {
           navigate("/admin/customer-onboarding-form");
         }

         return; 
       }

       if (!orderId) {
         return; 
       }

      if (!orderId) {
        toast.error("Order ID not found in notification");
        return;
      }

      // Close notifications dropdown
      // setShowNotifications(false);

      // Optional: Mark notification as read when clicked
      // await markAsRead(notification._id);

      if (notification.type === "new_order") {
        navigate("/admin/booking-management/online-appointments", {
          state: {
            order_id: orderId,
          },
        });
        return;
      }

      if (["order_queued", "order_scheduled"].includes(notification.type)) {
        if (isEmployee) {
          navigate("/home");
          return;
        }

        let listingType = "appointment"; // default

        switch (bookingType) {
          case "grooming":
            listingType = "appointment";
            break;

          case "boarding":
            listingType = "boarding";
            break;

          case "vet_clinic":
            listingType = "vet";
            break;

          default:
            listingType = "appointment";
        }

        navigate(`/admin/booking-management/listing?type=${listingType}`, {
          state: {
            order_id: orderId,
            booking_ref_id: notification.data?.booking_ref_id,
            notification_type: notification.type,
            booking_type: bookingType,
          },
        });
      }
    } catch (error) {
      console.error("Error opening order details:", error);
      toast.error("Failed to open order details");
    }
  };
  //   useEffect(() => {
  //   fetchNotifications();

  //   // Poll for new notifications every 30 seconds
  //   const interval = setInterval(fetchNotifications, 30000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <>
      {isMobile ? (
        <MobileNavbar setIsMobile={setIsMobile} isMobile={isMobile} />
      ) : (
        <div
          ref={dropdownRef}
          className="fixed top-0 left-0 right-0 z-50 flex flex-col w-full bg-white shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
        >
          {planWarning &&
            !planExpired &&
            !planBannerDismissed &&
            !isEmployee &&
            currentRole !== "executive" && (
              <div className="xl:hidden w-[calc(100%-24px)] md:w-[75%] mx-auto my-1.5 bg-[#0D7A70] text-white min-h-[38px] px-3.5 sm:px-4 py-1.5 rounded-xl shadow-md flex items-center justify-between gap-2.5 text-xs sm:text-sm border border-teal-600/30">
                <div className="flex items-center gap-2 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">
                  {/* Clock icon */}
                  <svg
                    className="w-4 h-4 flex-shrink-0 text-teal-200"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="9" />
                    <path strokeLinecap="round" d="M12 7v5l3 2" />
                  </svg>

                  {/* Primary Trial Status */}
                  <span className="font-bold flex-shrink-0">
                    {planWarning.headline}
                  </span>

                  {/* Middle Dot & Subtext */}
                  <span className="text-teal-200/80 hidden sm:inline flex-shrink-0 font-bold">
                    ·
                  </span>
                  <span className="text-teal-100 truncate min-w-0">
                    {planWarning.subtext}
                  </span>
                </div>

                {/* Actions: CTA Button + Dismiss Button */}
                <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                  <button
                    onClick={() => setChangePlanDrawerOpen(true)}
                    className="bg-white text-[#0D7A70] hover:bg-teal-50 active:scale-95 text-xs font-semibold px-3 py-1 rounded-lg transition-all shadow-xs whitespace-nowrap cursor-pointer"
                  >
                    {planWarning.cta}
                  </button>

                  <button
                    onClick={() => setPlanBannerDismissed(true)}
                    className="p-1 text-teal-200 hover:text-white hover:bg-white/10 rounded-lg transition-colors cursor-pointer"
                    aria-label="Dismiss notification"
                    title="Dismiss notification"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2.5}
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            )}

          {/* 2. NAVBAR ROW */}
          <div className={styles.sidebar_navbar}>{/* <Navbar></Navbar> */}</div>
          <div
            className={`w-full flex justify-between items-center px-6 bg-white ${
              isAdminUser ? "py-2.5" : ""
            }`}
          >
            <div className="flex-1 min-w-0 flex justify-start items-center gap-2">
              {!isEmployee && currentRole !== "executive" && (
                <button
                  type="button"
                  onClick={toggleSidebar}
                  aria-label="Toggle Sidebar"
                  className="p-2 rounded-lg text-gray-700 hover:text-[#1B4582] hover:bg-gray-100 transition-colors focus:outline-none flex xl:hidden items-center justify-center cursor-pointer mr-1"
                  title="Toggle Sidebar"
                >
                  <FaBars className="text-xl text-gray-700" />
                </button>
              )}
              <div
                className="sidebar-brand-text bg-white flex cursor-pointer"
                style={{ borderRadius: "10px" }}
                onClick={handleLogoClick}
              >
                <div className="mb-0 mr-4">
                  <img
                    src={logoimg}
                    style={{
                      width: "170px",
                    }}
                    alt="logo here"
                  />
                </div>
                {data?.vendor?.profile?.brand && (
                  <div className="flex items-center gap-2 border-l border-gray-300 pl-3 ml-2 h-7 mt-1">
                    {data?.vendor?.logo ? (
                      <img
                        src={data.vendor.logo}
                        alt="vendor logo"
                        className="h-9 w-9 rounded-full object-cover border border-gray-200"
                      />
                    ) : (
                      <div className="h-11 w-11 rounded-full bg-gray-100 flex items-center justify-center border border-gray-200">
                        <Building2 size={16} className="text-gray-500" />
                      </div>
                    )}
                    <span className="text-gray-600 font-medium text-sm md:text-base tracking-wide">
                      {data.vendor.profile.brand}
                    </span>
                  </div>
                )}
              </div>

              {/* Inline Plan Warning Banner inside Navbar for Desktop */}
              {planWarning &&
                !planExpired &&
                !planBannerDismissed &&
                !isEmployee &&
                currentRole !== "executive" && (
                  <div className="hidden xl:flex items-center gap-2 bg-[#0D7A70] text-white px-3 py-1.5 rounded-lg shadow-xs text-xs ml-3 border border-teal-600/30">
                    <svg
                      className="w-3.5 h-3.5 flex-shrink-0 text-teal-200"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                    >
                      <circle cx="12" cy="12" r="9" />
                      <path strokeLinecap="round" d="M12 7v5l3 2" />
                    </svg>
                    <span className="font-bold flex-shrink-0 whitespace-nowrap">
                      {planWarning.headline}
                    </span>
                    <span className="text-teal-200/80 font-bold">·</span>
                    <span className="text-teal-100 truncate max-w-[180px] 2xl:max-w-xs">
                      {planWarning.subtext}
                    </span>
                    <button
                      onClick={() => setChangePlanDrawerOpen(true)}
                      className="bg-white text-[#0D7A70] hover:bg-teal-50 active:scale-95 text-xs font-semibold px-2.5 py-0.5 rounded transition-all ml-1 cursor-pointer whitespace-nowrap"
                    >
                      {planWarning.cta}
                    </button>
                    <button
                      onClick={() => setPlanBannerDismissed(true)}
                      className="p-0.5 text-teal-200 hover:text-white rounded transition-colors cursor-pointer ml-0.5"
                      title="Dismiss notification"
                    >
                      <svg
                        className="w-3.5 h-3.5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2.5}
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                )}

              {/* Full‑page overlay when plan is expired */}
              {planExpired && (
                <PlanExpiredOverlay
                  onRenew={() => setChangePlanDrawerOpen(true)}
                  onLogout={logouthandler}
                />
              )}

              {/* Top navigation items (shown when allowed top items exist) */}
              {(() => {
                const navContext = {
                  currentRole,
                  allowedByName,
                  isShopOnly,
                  petShopActive,
                  boardingActive,
                  isSearchPermitted,
                  isOrdersPermitted,
                };
                const allowedTopNavItems = TOP_NAV_ITEMS.filter((item) =>
                  item.isAllowed(navContext),
                );

                if (allowedTopNavItems.length === 0) return null;

                const primaryNavItems = allowedTopNavItems.filter(
                  (item) => item.isPrimary,
                );
                const featuresDropdownItems = allowedTopNavItems.filter(
                  (item) => !item.isPrimary,
                );

                const isFeaturesActive = featuresDropdownItems.some((item) =>
                  item.isActive(urlLocation.pathname),
                );

                return (
                  <div className="flex items-center justify-center m-auto">
                    <ul className="flex text-black items-center gap-1 sm:gap-2">
                      {primaryNavItems.map((item) => {
                        if (item.isSearch) {
                          const active =
                            isStaffSearchOpen ||
                            item.isActive(urlLocation.pathname);
                          return (
                            <li
                              key={item.id}
                              className="relative"
                              ref={staffSearchRef}
                            >
                              <button
                                type="button"
                                onClick={() => {
                                  setIsStaffSearchOpen((prev) => !prev);
                                  setShowMoreDropdown(false);
                                }}
                                className={`flex flex-col items-center py-2 px-4 sm:px-5 hover:bg-[#EBF0FD] transition-all duration-300 rounded cursor-pointer ${
                                  active
                                    ? "bg-[#EBF0FD] text-[#3C6CE7] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                                    : "text-gray-700 hover:text-[#3C6CE7]"
                                }`}
                                title="Search Clients"
                                aria-label="Search Clients"
                              >
                                {item.icon()}
                                <span className="text-sm mt-1 font-semibold">
                                  {item.label}
                                </span>
                              </button>

                              {/* Compact Search Dropdown Panel */}
                              {isStaffSearchOpen && (
                                <div
                                  ref={staffSearchPanelRef}
                                  className="absolute left-1/2 -translate-x-1/2 top-full mt-2 z-50 bg-white p-3 rounded-2xl shadow-2xl border border-gray-200/90 flex items-center gap-2 w-72 sm:w-80"
                                >
                                  <div className="relative flex-1">
                                    <input
                                      type="text"
                                      placeholder="Search client..."
                                      value={searchTerm}
                                      onChange={(e) =>
                                        setSearchTerm(e.target.value)
                                      }
                                      onKeyDown={(e) => {
                                        handleKeyDown(e);
                                        if (e.key === "Enter") {
                                          setIsStaffSearchOpen(false);
                                        }
                                      }}
                                      autoFocus
                                      className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-black transition-all"
                                    />
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <MdSearch className="w-4 h-4 text-gray-400" />
                                    </div>
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setIsStaffSearchOpen(false);
                                      setSearchTerm("");
                                    }}
                                    className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                                    title="Close search"
                                  >
                                    <MdClose className="w-5 h-5" />
                                  </button>
                                </div>
                              )}
                            </li>
                          );
                        }

                        const active = item.isActive(urlLocation.pathname);
                        return (
                          <li key={item.id}>
                            <NavLink
                              to={item.route}
                              className={`flex flex-col items-center py-2 px-4 sm:px-5 hover:bg-[#EBF0FD] transition-all duration-300 rounded ${
                                active
                                  ? "bg-[#EBF0FD] text-[#3C6CE7] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                                  : "text-gray-700 hover:text-[#3C6CE7]"
                              }`}
                              onClick={() => {
                                setIsStaffSearchOpen(false);
                                setShowMoreDropdown(false);
                              }}
                            >
                              {item.icon()}
                              <span className="text-sm mt-1 font-semibold">
                                {item.label}
                              </span>
                            </NavLink>
                          </li>
                        );
                      })}

                      {/* Features (More) Dropdown Menu */}
                      {featuresDropdownItems.length > 0 && (
                        <li className="relative" ref={moreDropdownRef}>
                          <button
                            type="button"
                            onClick={() => {
                              setShowMoreDropdown((prev) => !prev);
                              setIsStaffSearchOpen(false);
                            }}
                            className={`flex flex-col items-center py-2 px-4 sm:px-5 hover:bg-[#EBF0FD] transition-all duration-300 rounded cursor-pointer ${
                              isFeaturesActive || showMoreDropdown
                                ? "bg-[#EBF0FD] text-[#3C6CE7] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                                : "text-gray-700 hover:text-[#3C6CE7]"
                            }`}
                            title="Features (More)"
                            aria-label="Features"
                            aria-expanded={showMoreDropdown}
                            aria-haspopup="menu"
                          >
                            <MdApps className="h-8 w-8" />
                            <span className="text-sm mt-1 font-semibold">
                              Features
                            </span>
                          </button>

                          {showMoreDropdown && (
                            <div
                              ref={morePanelRef}
                              className="absolute left-1/2 -translate-x-1/2 top-full mt-2 bg-white border border-gray-200/90 rounded-2xl shadow-2xl p-4 z-50 w-72 sm:w-84 max-w-[90vw]"
                            >
                              <div className="flex items-center justify-between pb-2.5 mb-3 border-b border-gray-100">
                                <div className="flex items-center gap-2">
                                  <MdApps className="text-xl text-[#3C6CE7]" />
                                  <span className="font-bold text-gray-800 text-base">
                                    Features
                                  </span>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => setShowMoreDropdown(false)}
                                  className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                                  title="Close"
                                >
                                  <MdClose className="w-5 h-5" />
                                </button>
                              </div>

                              <div className="grid grid-cols-2 gap-2.5 max-h-[60vh] overflow-y-auto p-0.5">
                                {featuresDropdownItems.map((item) => {
                                  const active = item.isActive(
                                    urlLocation.pathname,
                                  );
                                  return (
                                    <button
                                      key={item.id}
                                      type="button"
                                      onClick={() => {
                                        navigate(item.route);
                                        setShowMoreDropdown(false);
                                      }}
                                      className={`group flex flex-col items-center justify-center p-3 sm:p-3.5 rounded-xl border transition-all duration-200 cursor-pointer text-center relative ${
                                        active
                                          ? "bg-[#EBF0FD] text-[#3C6CE7] border-[#3C6CE7]/40 shadow-xs font-semibold ring-1 ring-[#3C6CE7]/20"
                                          : "bg-gray-50/70 hover:bg-[#EBF0FD]/60 text-gray-700 hover:text-[#3C6CE7] border-gray-100 hover:border-blue-100"
                                      }`}
                                    >
                                      {active && (
                                        <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-[#3C6CE7]" />
                                      )}
                                      <div
                                        className={`mb-1.5 flex items-center justify-center transition-transform duration-200 group-hover:scale-110 ${
                                          active
                                            ? "text-[#3C6CE7]"
                                            : "text-gray-600 group-hover:text-[#3C6CE7]"
                                        }`}
                                      >
                                        {item.icon({
                                          className: "h-7 w-7 sm:h-8 sm:w-8",
                                        })}
                                      </div>
                                      <span className="text-xs sm:text-sm font-medium leading-tight">
                                        {item.label}
                                      </span>
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </li>
                      )}
                    </ul>
                  </div>
                );
              })()}
            </div>

            <div className="relative flex items-center gap-x-2 md:gap-x-4 shrink-0">
              {/* Search (only for non-executive/admin users; executive uses main navbar Search) */}
              {!isEmployee &&
                currentRole !== "executive" &&
                allowedByName("Search") && (
                  <div className="relative" ref={adminSearchRef}>
                    {/* Tablet Search Icon button for admin */}
                    <div className="block xl:hidden">
                      <button
                        type="button"
                        onClick={() => setIsAdminSearchOpen((prev) => !prev)}
                        className="p-2 rounded-full text-gray-600 hover:text-[#3C6CE7] hover:bg-gray-100 transition-colors focus:outline-none flex items-center justify-center cursor-pointer"
                        title="Search clients"
                        aria-label="Search clients"
                      >
                        <MdSearch className="w-6 h-6 text-gray-600" />
                      </button>

                      {isAdminSearchOpen && (
                        <div className="absolute right-0 top-full mt-2 z-50 bg-white p-2.5 rounded-xl shadow-xl border border-gray-200 flex items-center gap-2 w-72 md:w-80">
                          <div className="relative flex-1">
                            <input
                              type="text"
                              placeholder="Search client..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                handleKeyDown(e);
                                if (e.key === "Enter") {
                                  setIsAdminSearchOpen(false);
                                }
                              }}
                              autoFocus
                              className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-black"
                            />
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <MdSearch className="w-4 h-4 text-gray-400" />
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              setIsAdminSearchOpen(false);
                              setSearchTerm("");
                            }}
                            className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                            title="Close search"
                          >
                            <MdClose className="w-5 h-5" />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Desktop Search Bar (only for non-staff on xl+ screens) */}
                    <div className="hidden xl:block relative w-52">
                      <input
                        type="text"
                        placeholder="Search client..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg
                          className="w-5 h-5 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                )}
              {/* NEW BUTTON with DROPDOWN for Add Sale */}
              {(isAdminUser || currentRole === "executive") && (
                <>
                  {(allowedByName("New Sale") || allowedByName("POS Sale")) && (
                    <div className="relative" ref={addSaleDropdownRef}>
                      <button
                        onClick={() => {
                          if (
                            allowedByName("New Sale") &&
                            allowedByName("POS Sale")
                          )
                            setShowAddSaleDropdown(!showAddSaleDropdown);
                          else if (allowedByName("New Sale")) {
                            setShowOrderDrawer(true);
                            setShowAddSaleDropdown(false);
                          } else {
                            navigate("/pos");
                            setShowAddSaleDropdown(false);
                          }
                        }}
                        aria-label="Add Sale"
                        aria-expanded={showAddSaleDropdown}
                        aria-haspopup="menu"
                        className={`group flex items-center justify-center gap-2 px-4 py-2 
                    bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-sm font-semibold 
                    rounded shadow-md shadow-indigo-500/20 hover:shadow-lg hover:shadow-indigo-500/40 
                    hover:scale-[1.03] active:scale-[0.97] transition-all duration-200 ease-out 
                    relative overflow-hidden
                    ${showAddSaleDropdown ? "shadow-lg scale-[1.02]" : ""}`}
                      >
                        {/* subtle shine effect */}
                        <span className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition duration-300"></span>
                        {/* icon */}
                        <FaPlus className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90" />
                        {/* text */}
                        <span className="relative">Sale</span>
                        {/* divider */}
                        <span className="w-px h-4 bg-white/30"></span>
                        {/* dropdown arrow */}
                        <FaChevronDown
                          className={`w-3 h-3 transition-transform duration-200 ${
                            showAddSaleDropdown ? "rotate-180" : ""
                          }`}
                        />
                      </button>

                      {showAddSaleDropdown &&
                        createPortal(
                          <div
                            ref={addSalePanelRef}
                            className="w-48 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden"
                            style={{
                              position: "fixed",
                              top:
                                (addSaleDropdownRef.current?.getBoundingClientRect()
                                  .bottom ?? 56) + 8,
                              left:
                                addSaleDropdownRef.current?.getBoundingClientRect()
                                  .left ?? 0,
                              zIndex: 200,
                            }}
                          >
                            {/* New Sale Button */}
                            {allowedByName("New Sale") && (
                              <button
                                onClick={() => {
                                  setShowOrderDrawer(true);
                                  setShowAddSaleDropdown(false);
                                }}
                                className="group flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-800 hover:bg-blue-50 transition-all duration-150"
                              >
                                <FaPlus className="h-4 w-4 text-blue-600 group-hover:scale-110 transition-transform" />
                                <span className="group-hover:translate-x-1 transition-transform">
                                  New Sale
                                </span>
                              </button>
                            )}

                            {/* POS Sale Button */}
                            {allowedByName("POS Sale") && petShopActive && (
                              <button
                                onClick={() => {
                                  navigate("/pos");
                                  setShowAddSaleDropdown(false);
                                }}
                                className="group flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-800 hover:bg-indigo-50 transition-all duration-150 border-t border-gray-100"
                              >
                                <FaPlus className="h-4 w-4 text-indigo-600 group-hover:scale-110 transition-transform" />
                                <span className="group-hover:translate-x-1 transition-transform">
                                  POS Sale
                                </span>
                              </button>
                            )}
                          </div>,
                          document.body,
                        )}
                    </div>
                  )}
                  {/* Notifications with Dropdown */}
                  {allowedByName("Notifications") &&
                    currentRole !== "executive" && (
                      <div className="relative" ref={notificationRef}>
                        <button
                          onClick={() =>
                            setShowNotifications(!showNotifications)
                          }
                          className="p-1 rounded-full hover:bg-gray-200 relative"
                        >
                          <HiOutlineBell className="h-8 w-8 text-gray-600" />
                          {unreadCount > 0 && (
                            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[20px] h-5 px-1 flex items-center justify-center font-medium">
                              {unreadCount > 99 ? "99+" : unreadCount}
                            </span>
                          )}
                        </button>

                        {showNotifications &&
                          createPortal(
                            <div
                              ref={notificationPanelRef}
                              className="w-[420px] bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden"
                              style={{
                                position: "fixed",
                                top:
                                  (notificationRef.current?.getBoundingClientRect()
                                    .bottom ?? 56) + 8,
                                right: Math.max(
                                  12,
                                  window.innerWidth -
                                    (notificationRef.current?.getBoundingClientRect()
                                      .right ?? window.innerWidth),
                                ),
                                zIndex: 200,
                              }}
                            >
                              {/* Header */}
                              <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
                                <div className="flex items-center gap-2">
                                  <HiOutlineBell className="h-5 w-5 text-gray-600" />
                                  <h3 className="font-semibold text-gray-800">
                                    Notifications
                                  </h3>
                                  {unreadCount > 0 && (
                                    <span className="bg-blue-100 text-blue-700 text-xs px-2 py-0.5 rounded-full">
                                      {unreadCount} new
                                    </span>
                                  )}
                                </div>
                                {unreadCount > 0 && (
                                  <button
                                    onClick={markAllAsRead}
                                    className="text-xs text-blue-600 hover:text-blue-800 font-medium transition-colors hover:underline"
                                  >
                                    Mark all as read
                                  </button>
                                )}
                              </div>

                              {/* Notifications List - Shows at least 5 items */}
                              <div className="max-h-[600px] overflow-y-auto divide-y divide-gray-100">
                                {notifications.length === 0 ? (
                                  <div className="flex flex-col items-center justify-center py-12 px-4">
                                    <HiOutlineBell className="h-16 w-16 text-gray-200 mb-3" />
                                    <p className="text-gray-500 text-sm font-medium">
                                      No notifications
                                    </p>
                                    <p className="text-gray-400 text-xs mt-1">
                                      We'll notify you when something arrives
                                    </p>
                                  </div>
                                ) : (
                                  notifications?.slice(0, 10).map(
                                    (
                                      notification, // Show up to 10 notifications
                                    ) => (
                                      <div
                                        key={notification._id}
                                        className={`px-4 py-3 hover:bg-gray-50 cursor-pointer transition-all duration-200 ${
                                          !notification.isRead
                                            ? "bg-blue-100 hover:bg-blue-200"
                                            : "hover:bg-gray-50"
                                        }`}
                                        onClick={() =>
                                          handleNotificationClick(notification)
                                        }
                                      >
                                        <div className="flex gap-3">
                                          <div className="flex-shrink-0 mt-1">
                                            {!notification.isRead && (
                                              <div className="relative">
                                                {notification.isRead &&
                                                  getNotificationIcon(
                                                    notification.type,
                                                  )}
                                                <span className="absolute -top-1 -right-1 w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                                              </div>
                                            )}
                                          </div>
                                          <div className="flex-1 min-w-0">
                                            <div className="flex justify-between items-start gap-2">
                                              <p
                                                className={`text-sm ${!notification.isRead ? "font-semibold text-gray-900" : "font-normal text-gray-700"}`}
                                              >
                                                {notification.title}
                                              </p>
                                              <span className="text-xs text-gray-400 flex-shrink-0 whitespace-nowrap">
                                                {formatDistanceToNow(
                                                  new Date(
                                                    notification.createdAt,
                                                  ),
                                                  { addSuffix: true },
                                                )}
                                              </span>
                                            </div>
                                            {/* Show order number prominently if it's an order notification */}
                                            {[
                                              "new_order",
                                              "order_queued",
                                              "order_scheduled",
                                              "booking_checkedin",
                                              "booking_checked_in",
                                              "booking_completed",
                                              "order_completed",
                                              "completed",
                                            ].includes(notification.type) &&
                                              notification.body && (
                                                <div className="mt-1.5 mb-2">
                                                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-lg px-3 py-1.5 shadow-sm">
                                                    <svg
                                                      className="w-4 h-4 text-orange-600"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      viewBox="0 0 24 24"
                                                    >
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                                                      />
                                                    </svg>
                                                    <span className="text-xs font-mono font-semibold text-orange-800">
                                                      {notification.body}
                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                )}
                              </div>

                              {/* Footer */}
                              {notifications.length > 0 && (
                                <div className="border-t border-gray-200 px-4 py-3 bg-gray-50">
                                  <button
                                    onClick={() => {
                                      setShowNotifications(false);
                                      toast.info(
                                        "Notifications page coming soon!",
                                      );
                                    }}
                                    className="text-sm text-center w-full text-blue-600 hover:text-blue-800 font-medium transition-colors hover:bg-blue-50 py-1.5 rounded-md"
                                  >
                                    View all notifications (
                                    {notifications.length})
                                  </button>
                                </div>
                              )}
                            </div>,
                            document.body,
                          )}
                      </div>
                    )}
                </>
              )}
              {/* Profile Dropdown */}

              <div className="relative">
                <button
                  ref={profileButtonRef}
                  className="flex items-center gap-x-1"
                  onClick={() => setIsDropDown((prev) => !prev)}
                >
                  <span className="text-xl rounded-full w-10 h-10 text-[#3BD82E] bg-[#D9FFDB] flex items-center justify-center">
                    {typeof data?.user?.name === "string" &&
                    data.user.name.length > 0
                      ? data.user.name[0].toUpperCase()
                      : "N/A"}
                  </span>
                  <span>
                    {isDropDown ? (
                      <MdKeyboardArrowUp />
                    ) : (
                      <MdKeyboardArrowDown />
                    )}
                  </span>
                </button>

                {isDropDown &&
                  createPortal(
                    <div
                      ref={profilePanelRef}
                      className="w-56 bg-white border border-gray-200 rounded-md shadow-lg"
                      style={{
                        position: "fixed",
                        top:
                          (profileButtonRef.current?.getBoundingClientRect()
                            .bottom ?? 56) + 8,
                        right: Math.max(
                          12,
                          window.innerWidth -
                            (profileButtonRef.current?.getBoundingClientRect()
                              .right ?? window.innerWidth),
                        ),
                        zIndex: 200,
                      }}
                    >
                      <div className="flex items-center px-4 py-3 border-b gap-3">
                        <span className="text-xl rounded-full w-10 h-10 text-[#3BD82E] bg-[#D9FFDB] flex items-center justify-center">
                          {typeof data?.user?.name === "string" &&
                          data.user.name.length > 0
                            ? data.user.name[0].toUpperCase()
                            : "N/A"}
                        </span>
                        <div className="flex flex-col">
                          <span className="text-sm font-semibold text-gray-800">
                            {data?.user?.name || "User"}
                          </span>
                          {data?.vendor?.profile?.companyName && (
                            <span className="text-xs text-gray-500">
                              {data.vendor.profile.companyName}
                            </span>
                          )}
                        </div>
                      </div>

                      <Link
                        to="/profile"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                        onClick={() => setIsDropDown(false)}
                      >
                        Profile
                      </Link>

                      {/* New: Change Password */}
                      <button
                        onClick={() => {
                          setIsDropDown(false);
                          setShowChangePassword(true);
                        }}
                        className="block w-full px-4 py-2 text-left text-gray-800 hover:bg-gray-100 transition"
                      >
                        Change Password
                      </button>

                      {showSwitchToAdmin && (
                        <button
                          onClick={() => handleRoleSwitch("admin")}
                          className="block w-full px-4 py-2 text-left text-gray-800 hover:bg-gray-100 transition"
                        >
                          Switch to Admin
                        </button>
                      )}

                      {showSwitchToExecutive && !isFreePlan && (
                        <button
                          onClick={() => handleRoleSwitch("executive")}
                          className="block w-full px-4 py-2 text-left text-gray-800 hover:bg-gray-100 transition"
                        >
                          Switch to Executive
                        </button>
                      )}

                      <Link
                        to="#"
                        onClick={logouthandler}
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100 border-t"
                      >
                        Logout
                      </Link>
                    </div>,
                    document.body,
                  )}
              </div>

              {/* Change Password Drawer */}
              {showChangePassword && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex justify-end">
                  <div className="w-full max-w-md bg-white h-full shadow-xl overflow-y-auto">
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-6">
                        <h2 className="text-2xl font-semibold">
                          Change Password
                        </h2>
                        <button
                          onClick={() => {
                            setShowChangePassword(false);
                            resetForm();
                          }}
                          className="text-gray-500 hover:text-gray-700 text-2xl"
                        >
                          ✕
                        </button>
                      </div>

                      <form
                        onSubmit={handleChangePassword}
                        className="space-y-5"
                      >
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Current Password
                          </label>
                          <div className="relative">
                            <input
                              type={showCurrentPassword ? "text" : "password"}
                              value={passwordData.currentPassword}
                              onChange={(e) =>
                                setPasswordData({
                                  ...passwordData,
                                  currentPassword: e.target.value,
                                })
                              }
                              className="w-full pr-10 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#3BD82E]"
                              required
                            />
                            <button
                              type="button"
                              onClick={() =>
                                setShowCurrentPassword((prev) => !prev)
                              }
                              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                              tabIndex={-1}
                            >
                              {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            New Password
                          </label>
                          <div className="relative">
                            <input
                              type={showNewPassword ? "text" : "password"}
                              value={passwordData.newPassword}
                              onChange={(e) =>
                                setPasswordData({
                                  ...passwordData,
                                  newPassword: e.target.value,
                                })
                              }
                              className="w-full pr-10 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#3BD82E]"
                              required
                            />
                            <button
                              type="button"
                              onClick={() =>
                                setShowNewPassword((prev) => !prev)
                              }
                              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                              tabIndex={-1}
                            >
                              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                          {((Array.isArray(errors.newPassword) &&
                            errors.newPassword.length > 0) ||
                            passwordValidationFeedback.length > 0) && (
                            <ul className="text-red-500 text-xs mt-1 list-disc list-inside space-y-1">
                              {(Array.isArray(errors.newPassword) &&
                              errors.newPassword.length > 0
                                ? errors.newPassword
                                : passwordValidationFeedback
                              ).map((message, index) => (
                                <li key={index}>{message}</li>
                              ))}
                            </ul>
                          )}
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Confirm New Password
                          </label>
                          <div className="relative">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              value={passwordData.confirmPassword}
                              onChange={(e) =>
                                setPasswordData({
                                  ...passwordData,
                                  confirmPassword: e.target.value,
                                })
                              }
                              className="w-full pr-10 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#3BD82E]"
                              required
                            />
                            <button
                              type="button"
                              onClick={() =>
                                setShowConfirmPassword((prev) => !prev)
                              }
                              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                              tabIndex={-1}
                            >
                              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                          {errors.confirmPassword && (
                            <p className="text-red-500 text-xs mt-1">
                              {errors.confirmPassword}
                            </p>
                          )}
                        </div>

                        <button
                          type="submit"
                          disabled={loading}
                          className="w-full bg-[#5D5CE8] hover:bg-[#7776f2 ] text-white py-3 rounded-lg font-medium transition disabled:opacity-70"
                        >
                          {loading ? "Updating..." : "Update Password"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <PlanChangeDrawer
        isOpen={changePlanDrawerOpen}
        onClose={() => setChangePlanDrawerOpen(false)}
        plans={plans}
        loadingPlans={loadingPlans}
        profileData={profileData}
        onUpgradeDowngrade={handleUpgradeDowngrade}
        onConfirm={handleConfirmPlanChange}
        selectedPlan={selectedPlan}
        selectedOptionalCategories={selectedOptionalCategories}
        setSelectedOptionalCategories={setSelectedOptionalCategories}
        selectedPrimaryCategory={selectedPrimaryCategory}
        setSelectedPrimaryCategory={setSelectedPrimaryCategory}
        showUpgradeConfirm={showUpgradeConfirm}
        showDowngradeConfirm={showDowngradeConfirm}
        setShowUpgradeConfirm={setShowUpgradeConfirm}
        setShowDowngradeConfirm={setShowDowngradeConfirm}
        getActivePlanInfo={getActivePlanInfo}
        shouldShowDowngrade={shouldShowDowngrade}
      />

      {showOrderDrawer && (
        <AddAppointment
          isOpen={showOrderDrawer}
          onClose={handleOrderDrawerClose}
          selectedSlotInfo={null}
          clearSlotSelection={() => {}}
          editMode={false}
          editingAppointment={null}
          onSave={handleOrderSaved}
          appointmentStatusRef={null}
          openBookingDetailsDrawer={(orderId) => {
            setSelectedOrderId(orderId);
            setShowOrderDrawer(false);
            setBookingDetailsDrawerOpen(true);
          }}
        />
      )}
      <BookingDetailsDrawer
        isOpen={bookingDetailsDrawerOpen}
        onClose={() => {
          setBookingDetailsDrawerOpen(false);
          setSelectedOrderId(null);
        }}
        orderId={selectedOrderId}
        onSave={async () => {
          setBookingDetailsDrawerOpen(false);
          setSelectedOrderId(null);
        }}
      />
    </>
  );
};

export default Sidebar;
